/**
 * Learning Hub progress — single source of truth for the completion
 * percentage so Home and Learning always agree. Derives the section count
 * from the seed and ignores unknown module IDs (e.g. legacy/renamed modules
 * persisted on the user profile). British English.
 */
import seedContent from '../../../backend/seed/learning.json';

const SECTION_IDS: ReadonlySet<string> = new Set(
  (seedContent.sections as { id: string }[]).map((s) => s.id),
);

export const LEARNING_SECTION_COUNT = SECTION_IDS.size;

/** Overall Learning Hub completion, 0–100. Unknown IDs are ignored. */
export function computeLearningPct(completedModules: readonly string[]): number {
  if (SECTION_IDS.size === 0) return 0;
  const known = completedModules.filter((id) => SECTION_IDS.has(id));
  const unique = new Set(known).size;
  return Math.round((unique / SECTION_IDS.size) * 100);
}
